module.exports = __webpack_public_path__ + "static/media/Ubuntu-Regular.84ea7c5c.ttf";